import { apiCall } from '../helpers/axios';

class TagService {

	static getAll() {
		return apiCall().get('/tags')
			.then(response => response.data)
	}

	static getOne(tagId) {
		return apiCall().get(`/tags/${tagId}`)
			.then(response => response.data)
	}

	static create(params) {
		return apiCall().post(`/tags`, params)
			.then(response => response.data);
	}

	static update(tagId, params) {
		return apiCall().put(`/tags/${tagId}`, params)
			.then(response => response.data);
	}

	static delete(tagId) {
		return apiCall().delete(`/tags/${tagId}`)
			.then(response => response.data);
	}
}

export default TagService


// WEBPACK FOOTER //
// ./src/services/tag-service.js